import React, { useEffect } from 'react';
import './Errors.css';
import { Button } from '../../component/form/Button';
import { useNavigate } from 'react-router-dom';
import CustomTable from '../../component/form/TableComponent';
import { useAuth } from '../../context/authContext';
import { useNotification } from '../../context/notificationContext';
import { useLoading } from '../../context/loadingContext';

const Server500: React.FC = () => {

    const nav = useNavigate();
    const { addNotification } = useNotification();

    const { user, association } = useAuth();
    const { setLoadingStatus } = useLoading();


    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const process_id = params.get('process_id');
    const error_code = params.get('error_code');

    const body = `` +
        `User ID: ${user.id}\n` +
        `User name: ${user.name}\n` +
        `Email: ${user.email}\n` +
        `Association ID: ${association.id}\n` +
        `Error Code: ${error_code}\n` +
        `P ID: ${process_id}\n` +
        `-------------------------------------\n` +
        `Description (optional):\n\n\n\n ` +
        `Best Regards\n` +
        `User name: ${user.name}\n`

    const columns = [
        { header: 'Process ID', accessor: 'process_id' },
        { header: 'Error Code', accessor: 'error_code' },
    ];

    const data = [
        { process_id: process_id, error_code: error_code },
    ]

    const handelSendEmail = () => {
        window.location.href = `mailto:support@sportifyapp.co?subject=${encodeURIComponent("Internal Server Error - 500 - " + error_code)}&body=${encodeURIComponent(body)}`
    }

    useEffect(() => {
        addNotification("Error", "There was an internal error processing your request", "error");
        setLoadingStatus(false)
    }, [])

    return (
        <div className="error-container">
            <h1 className="error-title">500 - Server Error</h1>
            <p className="error-message">
                This time its not your fault. You can help solve this problem by sending an email to support@sportifyapp.co with the following data. Or just click Quick eamil to create a quick email:
            </p>
            <CustomTable columns={columns} data={data} buttons={[]} />

            <Button name='Quick Email' action={handelSendEmail} />
            <Button name='Torna alla Home' action={() => nav('/')} />
        </div>
    );
};

export default Server500;
